const rawData = {
    cameras:
        {
            "Bedfordshire": 100,
            "Berkshire": 127,
            "Buckinghamshire": 66,
            "Cambridgeshire": 71,
            "Cheshire": 101,
            "Cornwall": 42,
            "County Durham": 14,
            "Cumbria": 39,
            "Derbyshire": 100,
            "Devon": 69,
            "Dorset": 67,
            "East Riding of Yorkshire": 22,
            "East Sussex": 30,
            "Essex": 196,
            "Gloucestershire": 41,
            "Greater London": 161,
            "Greater Manchester": 176,
            "Hampshire": 126,
            "Herefordshire": 6,
            "Hertfordshire": 92,
            "Isle of Wight": 71,
            "Kent": 123,
            "Kingston Upon Hull": 7,
            "Lancashire": 274,
            "Leicestershire": 65,
            "Lincolnshire": 94,
            "Merseyside": 59,
            "Norfolk": 105,
            "North Yorkshire": 37,
            "Northamptonshire": 100,
            "Northumberland": 40,
            "Nottinghamshire": 92,
            "Oxfordshire": 93,
            "Shropshire": 29,
            "Somerset": 92,
            "South Yorkshire": 76,
            "Staffordshire": 77,
            "Suffolk": 36,
            "Surrey": 79,
            "Tyne and Wear": 68,
            "Warwickshire": 43,
            "West Midlands": 118,
            "West Sussex": 48,
            "West Yorkshire": 139,
            "Wiltshire": 16,
            "Worcestershire": 42,
            "York": 3
        },
    potholes:
        {
            "Bedfordshire": 5113,
            "Berkshire": 2307,
            "Buckinghamshire": 2525,
            "Cambridgeshire": 1778,
            "Cheshire": 1343,
            "Cornwall": 997,
            "County Durham": 401,
            "Cumbria": 1217,
            "Derbyshire": 2291,
            "Devon": 1019,
            "Dorset": 809,
            "East Riding of Yorkshire": 504,
            "East Sussex": 7245,
            "Essex": 4597,
            "Gloucestershire": 3208,
            "Greater London": 6319,
            "Greater Manchester": 6157,
            "Hampshire": 4673,
            "Herefordshire": 1320,
            "Hertfordshire": 5755,
            "Isle of Wight": 509,
            "Kent": 4733,
            "Kingston Upon Hull": 109,
            "Lancashire": 4221,
            "Leicestershire": 786,
            "Lincolnshire": 1137,
            "Merseyside": 1370,
            "Norfolk": 1598,
            "North Yorkshire": 1746,
            "Northamptonshire": 1398,
            "Northumberland": 847,
            "Nottinghamshire": 1312,
            "Oxfordshire": 2339,
            "Shropshire": 898,
            "Somerset": 1014,
            "South Yorkshire": 3276,
            "Staffordshire": 1676,
            "Suffolk": 1713,
            "Surrey": 6183,
            "Tyne and Wear": 976,
            "Warwickshire": 803,
            "West Midlands": 4244,
            "West Sussex": 2810,
            "West Yorkshire": 3047,
            "Wiltshire": 990,
            "Worcestershire": 601,
            "York": 250
        },
    speed:
        {
            "Bedfordshire": 27.57,
            "Berkshire": 24.73,
            "Buckinghamshire": 30.2,
            "Cambridgeshire": 31.9,
            "Cheshire": 28.23,
            "Cornwall": 31.9,
            "County Durham": 34.1,
            "Cumbria": 31.7,
            "Derbyshire": 30.2,
            "Devon": 32.8,
            "Dorset": 35,
            "East Riding of Yorkshire": 36.6,
            "East Sussex": 29.1,
            "Essex": 31.2,
            "Gloucestershire": 29.5,
            "Greater London": 16.29,
            "Greater Manchester": 18.5,
            "Hampshire": 32.1,
            "Herefordshire": 33.1,
            "Hertfordshire": 30,
            "Isle of Wight": 24.8,
            "Kent": 29.2,
            "Kingston Upon Hull": 16.6,
            "Lancashire": 25.5,
            "Leicestershire": 31.3,
            "Lincolnshire": 36.2,
            "Merseyside": 21.5,
            "Norfolk": 31.4,
            "North Yorkshire": 33.7,
            "Northamptonshire": 30.9,
            "Northumberland": 36.1,
            "Nottinghamshire": 29.7,
            "Oxfordshire": 32.1,
            "Shropshire": 35,
            "Somerset": 30.1,
            "South Yorkshire": 25.2,
            "Staffordshire": 29,
            "Suffolk": 30.4,
            "Surrey": 25.6,
            "Tyne and Wear": 24.2,
            "Warwickshire": 30.2,
            "West Midlands": 20.1,
            "West Sussex": 31.4,
            "West Yorkshire": 22.5,
            "Wiltshire": 32.2,
            "Worcestershire": 31.8,
            "York": 22.3
        },
    delay:
        {
            "Bedfordshire": 41.63,
            "Berkshire": 57.42,
            "Buckinghamshire": 30.6,
            "Cambridgeshire": 30.1,
            "Cheshire": 40.4,
            "Cornwall": 24.3,
            "County Durham": 23.2,
            "Cumbria": 25.1,
            "Derbyshire": 28.5,
            "Devon": 24.5,
            "Dorset": 22.6,
            "East Riding of Yorkshire": 17.7,
            "East Sussex": 31.1,
            "Essex": 32.8,
            "Gloucestershire": 34,
            "Greater London": 101.9,
            "Greater Manchester": 76,
            "Hampshire": 27.5,
            "Herefordshire": 23.5,
            "Hertfordshire": 36.4,
            "Isle of Wight": 38.8,
            "Kent": 35.3,
            "Kingston Upon Hull": 86.8,
            "Lancashire": 30.4,
            "Leicestershire": 32.1,
            "Lincolnshire": 20.7,
            "Merseyside": 61.7,
            "Norfolk": 28.8,
            "North Yorkshire": 23.1,
            "Northamptonshire": 30.2,
            "Northumberland": 19.7,
            "Nottinghamshire": 32.1,
            "Oxfordshire": 30.3,
            "Shropshire": 22.8,
            "Somerset": 29.1,
            "South Yorkshire": 44.2,
            "Staffordshire": 31.2,
            "Suffolk": 29.3,
            "Surrey": 45.5,
            "Tyne and Wear": 46.8,
            "Warwickshire": 31.2,
            "West Midlands": 69,
            "West Sussex": 29.8,
            "West Yorkshire": 53.1,
            "Wiltshire": 24.4,
            "Worcestershire": 29.2,
            "York": 58
        }
};